import React from "react";
import { connect } from "react-redux";

import backgroundImage from "../../../../_assets/images/user_images/user_image_2.jpg";
import user from "../../../../_assets/images/users/user_1.jpg";
import getMemberProfilePicture from "../../../../_selectors/profileSelectors/getMemberProfilePicture";
import getMemberOnlineStatus from "../../../../_selectors/profileSelectors/getMemberOnlineStatus";
import getMemberLocationForProfile from "../../../../_selectors/profileSelectors/getMemberLocationForProfile";
import getMemberName from "../../../../_selectors/profileSelectors/getMemberName";
import getMemberLikesCount from "../../../../_selectors/profileSelectors/getMemberLikesCount";
import getMemberConnectsCount from "../../../../_selectors/profileSelectors/getMemberConnectsCount";

const ProfileCover = ({
  profilePic,
  isOnline,
  location,
  name,
  likes,
  connects
}) => {
  return (
    <div
      class="page-profile"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div class="profile profile-transparent">
        <div class="profile-image">
          <img src={profilePic} />
          <div class="profile-badges">
            <a
              title={`Members who liked ${name}'s profile`}
              class="profile-badges-left"
            >
              <i class="fa fa-thumbs-up" /> {likes}
            </a>
            <a
              class="profile-badges-right"
              title={`Members who connected with ${name}`}
            >
              <i class="fa fa-heartbeat" /> {connects}
            </a>
          </div>
          <div
            className={
              isOnline ? "profile-status online" : "profile-status away"
            }
            title={isOnline ? `${name} is Online` : `${name} is Offline`}
          />
        </div>
        <div class="profile-info">
          <h4>{name}</h4>
          {location ? (
            <span>
              <i class="fa fa-map-marker" /> {` ${location}`}
            </span>
          ) : null}
        </div>
      </div>

      <div class="page-profile-stats" />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  profilePic: getMemberProfilePicture(state),
  isOnline: getMemberOnlineStatus(state),
  location: getMemberLocationForProfile(state),
  name: getMemberName(state),
  likes: getMemberLikesCount(state),
  connects: getMemberConnectsCount(state)
});

export default connect(mapStateToProps)(ProfileCover);



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileCover/index.js